import redux from '../../Images/techIcons/redux.svg'
import reactjs from '../../Images/techIcons/reactjs.svg'
import nodejs from '../../Images/techIcons/nodejs.svg'
import mongo from '../../Images/techIcons/mongo.svg'
import javascript from '../../Images/techIcons/javascript.svg'
import express from '../../Images/techIcons/express.svg'
import typescript from '../../Images/techIcons/typescript.svg'
import nextjs from '../../Images/techIcons/nextjs.svg'

//phonespecs
import specs1 from '../../Images/phonespecsimages/1.jfif'
// chat
import chat5 from '../../Images/chatimages/5.jfif'
// cryptoApp
import crypto1 from '../../Images/cryptoimages/1.jfif'
// MealGenerator
import meal5 from '../../Images/mealgeneratorimages/5.jfif'
// MemoryGame
import memory1 from '../../Images/memoryimages/1.jfif'


const previewProjectsData = [
  {
    id: 1,
    src: chat5,
    title: 'Chat-App',
    techIcons: [
      reactjs,
      nodejs,
      redux,
      mongo,
      express,
    ],
    description: `Full-Stack Chat app with users and private messaging`,
  },
  {
    id: 2,
    src: specs1,
    title: 'PhoneSpecs',
    techIcons: [
      nextjs,
      typescript,
    ],
    description: `Website created to provide phones information and specifications`,
  },
  {
    id: 3,
    src: crypto1,
    title: 'CryptoApp',
    techIcons: [
      nextjs,
      javascript,
    ],
    description: `Website created to provide Cryptocurrency information and statistics`,
  },
  {
    id: 4,
    src: meal5,
    title: 'Recipe Generator',
    techIcons: [
      reactjs,
      javascript,
    ],
    description: `An app that lets you generate a random meal or search for a specific one`,
  },
  {
    id: 5,
    src: memory1,
    title: 'Memory Game',
    techIcons: [
      reactjs,
      javascript,
    ],
    description: `React based memory game`,
  },
];

export default previewProjectsData;
